import { Injectable } from '@angular/core';
@Injectable()
export class StateService {
  storage = localStorage;

  deleteValue(key: string) {
    this.storage.removeItem(key);
  }

  deleteValues(keys: Array<string>) {
    keys.forEach((key) => {
      this.deleteValue(key);
    });
  }

  getValue(key: string, deleteValue: boolean = false) {
    const result = this.storage.getItem(key);

    if (deleteValue) {
      this.deleteValue(key);
    }

    return result;
  }

  setValue(key: string, value: any) {
    this.storage.setItem(key, value);
  }
}
